import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/Layout'
import {Post} from '../components/Main'
// import { rhythm, scale } from '../utils/typography'

const BlogPostTemplate = ({ data, pageContext, location }) => {
    const post = data.gcms.post
    const { previous, next } = pageContext

    return (
        <Layout
            location={location}
            title={post.title}
            // description={post.preview}
        >
            <Post
                post={post}
                next={next}
                previous={previous}
                location={location}
            />
        </Layout>
    )
}

export default BlogPostTemplate

export const pageQuery = graphql`
    query BlogPostBySlug($id: ID) {
        site {
            siteMetadata {
                title
                author {
                    name
                }
            }
        }
        gcms {
            post(where: { id: $id }) {
                id
                createdAt
                title
                category
                image {
                    url
                }
                slug
                body {
                    html
                }
            }
        }
    }
`
